import VanillaTilt from 'vanilla-tilt';
import Vimeo from '@vimeo/player';

document.addEventListener('DOMContentLoaded', function() {

    //Input autoslash
    require('./autoslash.js');

    //Video Viméo
    const iframe = document.querySelector('#diaporama .el-content iframe');

    if(iframe) {

        setTimeout(function() {

            var player = new Vimeo(iframe);
            if(player.constructor.name == 'Player' && sessionStorage.getItem('video-accueil') == null) { //Vidéo Vimeo
                player.play().then(() => { // Autoplay started!
                    sessionStorage.setItem('video-accueil', true);
                }).catch(error => {
                    console.log(error);
                });
            }
        }, 1800);
    }

    //Tilt
    const elements = document.querySelectorAll(".card .el-item");
    VanillaTilt.init(elements, {
        reverse: true,
        max: 20,
		speed: 600
    });

    //Formules
    const formules = document.querySelector('#formules');
    const anniversaire_form = document.querySelector('#anniversaire-form');
    const input_formule = document.querySelector('#formule');

    if(formules) {

        const items = formules.querySelectorAll(".el-item");

        if(items.length > 0) {

            items.forEach((item, index) => {

                const formule_button = item.querySelector("[data-formule]");
                formule_button.addEventListener('click', function() {

                    UIkit.notification('Merci de compléter les champs suivants', {
                        status: 'success',
                        pos: 'top-left'
                    });

                    //Scroll vers le bas
                    UIkit.scroll(formule_button).scrollTo(anniversaire_form);

                    //Gestion des autres items
                    removeClassFromElements(items, 'active');
                    addClassFromElements(items, 'disabled');
                    //Item en question
                    item.classList.remove('disabled');
                    item.classList.add('active');
                    //Ecriture dans l'input
                    input_formule.value = formule_button.dataset.formule;
                });
            });
        }
    }

});

function toggleClassFromElements(elements, classe) {
    elements.forEach((element) => {
        element.classList.toggle(classe);
    });
}

function addClassFromElements(elements, classe) {
    elements.forEach((element) => {
        element.classList.add(classe);
    });
}

function removeClassFromElements(elements, classe) {
    elements.forEach((element) => {
        element.classList.remove(classe);
    });
}
